import React, { useState } from 'react';
import { Phone, MessageCircle, Menu, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Accueil', href: '#accueil' },
    { name: 'Services', href: '#services' },
    { name: 'Magies', href: '#magies' },
    { name: 'Témoignages', href: '#temoignages' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-24">
          {/* Logo */}
          <a href="#accueil" className="flex items-center space-x-2 sm:space-x-3 group">
            <Sparkles className="w-7 h-7 sm:w-10 sm:h-10 text-amber-500 group-hover:text-amber-400 transition-colors" />
            <div className="flex flex-col">
              <span className="text-base sm:text-2xl font-bold text-amber-500 tracking-wide">RETOUR AFFECTIF</span>
              <span className="text-[10px] sm:text-xs text-amber-500/70 tracking-widest font-medium">RAPIDE & PUISSANT</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-200 hover:text-amber-500 transition-colors duration-300 text-base font-medium tracking-wide"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Desktop Contact Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>
              <Button variant="outline" className="border-amber-500/50 text-amber-500 hover:bg-amber-500 hover:text-black transition-all duration-300 text-sm lg:text-base font-semibold px-3 lg:px-5 py-4 lg:py-5">
                <Phone className="w-4 h-4 lg:w-5 lg:h-5 mr-2" />
                <span className="hidden lg:inline">{contactInfo.phone}</span>
                <span className="lg:hidden">Appeler</span>
              </Button>
            </a>
            <a href={contactInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button className="bg-green-600 hover:bg-green-700 text-white transition-all duration-300 text-sm lg:text-base font-semibold px-3 lg:px-5 py-4 lg:py-5">
                <MessageCircle className="w-4 h-4 lg:w-5 lg:h-5 mr-2" />
                WhatsApp
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-amber-500 p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-amber-500/20 animate-in slide-in-from-top duration-300">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-200 hover:text-amber-500 transition-colors text-base font-medium px-2 py-3"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <div className="flex flex-col space-y-3 pt-4 border-t border-amber-500/20">
                <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>
                  <Button variant="outline" className="w-full border-amber-500/50 text-amber-500 hover:bg-amber-500 hover:text-black text-base py-5">
                    <Phone className="w-5 h-5 mr-2" />
                    {contactInfo.phone}
                  </Button>
                </a>
                <a href={contactInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                  <Button className="w-full bg-green-600 hover:bg-green-700 text-white text-base py-5">
                    <MessageCircle className="w-5 h-5 mr-2" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
